import { useEffect } from "react";
import GPXMap from "./GPXMap";
import './Results.css';

const Results = ({ changeParams, newDrawing, startOver, results }) => {
  useEffect(() => {
    console.log(results);
  }, [results]);

  return (
    <div id='results' className='inner-container'>
      <div className='title'>Results</div>

      <div className='bump-out'>
        <div className='results-area'>
          {results.map((result) =>
            <GPXMap result={result}></GPXMap>
          )}
        </div>

        <div className='button-container'>
          <button className='button-74' type="button" onClick={newDrawing}>New drawing</button>
          <button className='button-74' type="button" onClick={changeParams}>Change Parameters</button>
          <button className='button-74' type="button" onClick={startOver}>Start over</button>
        </div>
      </div>
    </div>
  )
}

export default Results;